import { Stack } from '@mui/material';
import { Fare, FareStatus } from '@silbo/core';
import SpecificityChip from '../../bed-management/components/SpecificityChip';
import { useEncounterIsolationSpecificities } from '../../encounter/api/useEncounterIsolationSpecificities';

/** Le brancardier perd l'accès au séjour dès que sa mission se termine : rien à demander au serveur. */
const closedStatuses: FareStatus[] = ['DONE', 'CANCELED', 'FAILED'];

/** L'isolement du patient de la mission : le brancardier n'a pas accès aux hébergements, le serveur les lit pour lui. */
export const FarePatientIsolation = ({ fare }: { fare: Fare }) => {
  const isClosed = !!fare.status && closedStatuses.includes(fare.status);
  const specificities = useEncounterIsolationSpecificities({
    visitId: isClosed ? undefined : fare.patient?.id,
    from: fare.createdAt,
  });

  if (!specificities.length) {
    return null;
  }

  return (
    <Stack direction="row" flexWrap="wrap" gap="6px">
      {specificities.map((specificity) => (
        <SpecificityChip
          key={typeof specificity === 'string' ? specificity : specificity.name}
          specificity={specificity}
        />
      ))}
    </Stack>
  );
};
